module.exports = __webpack_public_path__ + "static/fonts/iconfont.e802f04.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1610088025011
// module id = 7Fy/
// module chunks = 78